import JobHardware from '@codeDelivery/views/JobHardware/JobHardware';

export default JobHardware;
